const SYMBOL = { EUR: "€", GBP: "£", CHF: "CHF", SEK: "SEK", CZK: "CZK", PLN: "PLN", AUD: "AUD", USD: "$", XPF: "XPF" };
let CUR = { code: "EUR", rate: 1 };
// Devise d'affichage : les montants restent calculés en € et sont convertis à l'affichage.
export const setDisplayCurrency = (code = "EUR", rate = 1) => { CUR = { code: code || "EUR", rate: Number(rate) || 1 }; };
export const displayCurrency = () => CUR;
export const curSymbol = () => SYMBOL[CUR.code] || CUR.code;
const fmt = (v, digits) => v.toLocaleString("fr-FR", { minimumFractionDigits: digits, maximumFractionDigits: digits }) + " " + (SYMBOL[CUR.code] || CUR.code);

export function euro(n) {
  return fmt(Number(n || 0) * CUR.rate, CUR.code === "XPF" ? 0 : 2);
}

export function euroInt(n) {
  return fmt(Math.round(Number(n || 0) * CUR.rate), 0);
}

export function eurOnly(n) {
  return Math.round(Number(n || 0)).toLocaleString("fr-FR") + " €";
}

export function dateFR(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", {
      day: "2-digit", month: "2-digit", year: "numeric",
    });
  } catch {
    return iso;
  }
}

export const stripParen = (s) => (s || "").replace(/\s*\([^)]*\)/g, "").replace(/\s{2,}/g, " ").trim();
export const extractParen = (s) => [...String(s || "").matchAll(/\(([^)]*)\)/g)].map((m) => m[1].trim()).filter(Boolean).join(" · ");

// Prix public : on part du TTC catalogue (arrondi, TVA de référence 20%) et on en déduit le HT,
// pour éviter les écarts de centime dus au stockage du HT.
export const BASE_VAT = 0.2;
export const depositPct = (dep, total) => (Number(total) > 0 ? String(Math.round((Number(dep) || 0) / Number(total) * 1000) / 10).replace(".", ",") : "35");

export function priceTtcOf(item, vat = BASE_VAT) {
  const base = (item && item.public_ttc != null && item.public_ttc !== "")
    ? Number(item.public_ttc)
    : Number((item && item.public_ht) || 0) * (1 + BASE_VAT);
  const v = (vat == null) ? BASE_VAT : vat;
  const ttc = base * (1 + v) / (1 + BASE_VAT);
  return Math.round(ttc * 100) / 100;
}
